module.exports = "<p class=\"<%= gwTileHeaderText %>\">{{text}}</p>"